import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Spinner, ProgressBar } from "react-bootstrap";
import { useSharedData } from "../context/sharedDataContext";
import HelperFunction from "../util/helper";
import TransactionModal from "./transactionModal";
import SavingsPlanModal from "./savingsPlanModal";
import InitiatePayment from "./initiatePaymentModal";

export default function QuickActions() {
    const { summery, loading } = useSharedData();
    const [level, setLevel] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [showPlanModal, setShowPlanModal] = useState(false);
    const [showInitiatePayementModal, setShowInitiatePayementModal] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setLevel((prev) => (prev + 1) % 5);
        }, 1500);

        return () => clearInterval(interval);
    }, []);

    if(loading) {
        return <div className="d-flex justify-content-center my-5">
                    <Spinner animation="border" />
                </div>
    }
    const { total, target } = HelperFunction.totalPackages(summery)

    return(
        <>
            <div className="quick-actions">
                <div className="action-item" onClick={() => setShowModal(true)}>
                    <div className="action-icon"><i className="bi bi-plus-square"></i></div>
                    <span>Deposit</span>
                </div>
                <div className="action-item" onClick={() => setShowPlanModal(true)}>
                    <div className="action-icon"><i className="bi bi-piggy-bank me-2"></i></div>
                    <span>Create Plan</span>
                </div>
                <div className="action-item" onClick={() => setShowInitiatePayementModal(true)}>
                    <div className="action-icon"><i className="bi bi-send-arrow-down"></i></div>
                    <span>Withdraw</span>
                </div>
                <div className="action-item">
                    <div className="action-icon"><i className="bi bi-clock-history"></i></div>
                    <span>History</span>
                </div>
            </div>

            {loading ? (
                    <div className="d-flex justify-content-center my-5">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <Card className="daily-limit-card mb-4">
                        <Card.Body>
                            <h5><i className={`bi bi-reception-${level}`}></i> Progress</h5>
                            <div className="limit-info">
                                <span>{HelperFunction.formatCurrency(total)} of {HelperFunction.formatCurrency(target)}</span>
                                <span className="limit-percentage">{HelperFunction.getPercent(total, target)}%</span>
                            </div>
                            <ProgressBar 
                                now={HelperFunction.getPercent(total, target)} 
                                className="limit-progress"
                                variant="success"
                            />
                        </Card.Body>
                    </Card>
            )}

            {/* Modal */}
            <TransactionModal show={showModal} onClose={() => setShowModal(false)} />
            <SavingsPlanModal show={showPlanModal} onClose={() => setShowPlanModal(false)} />
            <InitiatePayment show={showInitiatePayementModal} onClose={() => setShowInitiatePayementModal(false)} />
        </>
    )
}
